module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    ref: "select",
    attrs: {
      "items": _vm.options,
      "item-text": "Name",
      "item-value": "value",
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "true",
      "label": "Frequency",
      "id": "frequency_ddl"
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d0e25c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/FrequencyDDL.vue
// module id = 1932
// module chunks = 0